import { useQuery } from "@tanstack/react-query";

import { getField, getFieldAdmin } from "services";

import { getEnvironment } from "utils";

import { GET_FIELD_DETAILS } from "consts";

import { FieldDetails } from "models";

export const useGetFieldDetails = ({ id, includeDisabledFields }: { id: string; includeDisabledFields?: boolean }) => {
  const isAdmin = getEnvironment().admin;
  const queryFn = isAdmin ? getFieldAdmin : getField;

  return useQuery<FieldDetails>({
    queryKey: [GET_FIELD_DETAILS, id, includeDisabledFields],
    queryFn: ({ signal }) => queryFn({ signal, includeDisabledFields, id }),
    placeholderData: {} as FieldDetails,
    enabled: !!id,
    // TODO: adding this stale time causes the FDP page to go into an infinite loading state. I'll comment it out for now as a quick fix, but we should have another look at this.
    staleTime: 1000 * 60 * 60 * 24, // 1 day
  });
};
